function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m.3 187.9v123.4c0 6.9 5.6 12.6 12.6 12.6h206.1c10 0 16-11.2 10.5-19.5l-13.1-19.8c-45.3-68.3-121.7-109.3-203.5-109.3-7 0-12.6 5.6-12.6 12.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.3 12.6v123.4c0 6.9 5.6 12.6 12.6 12.6h206.1c10 0 16-11.2 10.5-19.5l-13.1-19.8c-45.3-68.3-121.7-109.3-203.5-109.3-7 0-12.6 5.6-12.6 12.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.3 363.2v123.4c0 6.9 5.6 12.6 12.6 12.6h206.1c10 0 16-11.2 10.5-19.5l-13.1-19.8c-45.3-68.3-121.7-109.3-203.5-109.3-7 0-12.6 5.6-12.6 12.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m499.5 311.3v-123.4c0-6.9-5.6-12.6-12.6-12.6h-206.1c-10 0-16 11.2-10.5 19.5l13.1 19.8c45.2 68.2 121.6 109.2 203.4 109.2 7 0 12.7-5.6 12.7-12.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m499.5 486.6v-123.4c0-6.9-5.6-12.6-12.6-12.6h-206.1c-10 0-16 11.2-10.5 19.5l13.1 19.8c45.2 68.2 121.6 109.2 203.4 109.2 7 0 12.7-5.6 12.7-12.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m499.5 136v-123.4c0-6.9-5.6-12.6-12.6-12.6h-206.1c-10 0-16 11.2-10.5 19.5l13.1 19.8c45.2 68.2 121.6 109.2 203.4 109.2 7 0 12.7-5.6 12.7-12.5z"
}));

function SvgDalta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 500 500",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDalta);
export default __webpack_public_path__ + "static/media/Dalta.a2380690.svg";
export { ForwardRef as ReactComponent };